import simulatorTrainingRoutes from 'modules/simulatorTrainings/common/routing/routes'

const base = `${simulatorTrainingRoutes.instructorSL}/schedules`

const routes = {
  root: base,
  list: `${base}/list`,
  edit: `${base}/edit`,
  create: `${base}/create`,
}

export default routes
